import React from "react";

const SubscriptionSummary = ({
  companySubscriptionDetails,
  className = "",
}) => {
  return (
    <div className={`space-y-3 text-right capitalize ${className}`}>
      {/* Recurring Total */}
      {companySubscriptionDetails?.model?.detail?.recurring_amount ||
      companySubscriptionDetails?.detail?.recurring_amount ? (
        <div className="flex items-center justify-end space-x-1">
          <p>Sub Total: </p>
          <p>
            $
            {companySubscriptionDetails?.model?.detail?.recurring_amount ||
              companySubscriptionDetails?.detail?.recurring_amount}
          </p>
        </div>
      ) : null}

      {/* Others Total */}
      {companySubscriptionDetails?.model?.detail?.others_amount ||
      companySubscriptionDetails?.detail?.others_amount ? (
        <div className="flex items-center justify-end space-x-1">
          <p>Others Total: </p>
          <p>
            $
            {companySubscriptionDetails?.model?.detail?.others_amount ||
              companySubscriptionDetails?.detail?.others_amount}
          </p>
        </div>
      ) : null}

      {/* GST */}
      {companySubscriptionDetails?.model?.detail?.gst ||
      companySubscriptionDetails?.detail?.gst ? (
        <div className="flex items-center justify-end space-x-1">
          <p>GST: </p>
          <p>
            $
            {companySubscriptionDetails?.model?.detail?.gst_amount ||
              companySubscriptionDetails?.detail?.gst_amount}{" "}
            (
            {companySubscriptionDetails?.model?.detail?.gst ||
              companySubscriptionDetails?.detail?.gst}
            )
          </p>
        </div>
      ) : null}

      {/* Discount fees */}
      {companySubscriptionDetails?.model?.detail?.discount ||
      companySubscriptionDetails?.detail?.discount ? (
        <div className="flex items-center justify-end space-x-1">
          <p>
            Discount (
            {companySubscriptionDetails?.model?.detail?.discount ||
              companySubscriptionDetails?.detail?.discount}
            %): $
            {companySubscriptionDetails?.model?.detail?.discount_amount ||
              companySubscriptionDetails?.detail?.discount_amount}
          </p>
        </div>
      ) : null}

      {/* Incorporate fees */}
      {/* {companySubscriptionDetails?.model?.detail?.incorporation_fees ||
      companySubscriptionDetails?.detail?.incorporation_fees ? (
        <div className="flex items-center justify-end space-x-1">
          <p>Incorporate Fees: </p>
          <p>
            $
            {companySubscriptionDetails?.model?.detail?.incorporation_fees ||
              companySubscriptionDetails?.detail?.incorporation_fees}
          </p>
        </div>
      ) : null} */}

      {/* govt fees */}
      {/* {companySubscriptionDetails?.model?.detail?.govt_fees ||
      companySubscriptionDetails?.detail?.govt_fees ? (
        <div className="flex items-center justify-end space-x-1">
          <p>Govt Fees: </p>
          <p>
            $
            {companySubscriptionDetails?.model?.detail?.govt_fees ||
              companySubscriptionDetails?.detail?.govt_fees}
          </p>
        </div>
      ) : null} */}

      {/* Total */}
      {companySubscriptionDetails?.model?.detail?.total ||
      companySubscriptionDetails?.detail?.total ? (
        <div className="flex items-center justify-end space-x-1">
          <p>Total: </p>
          <p>
            $
            {companySubscriptionDetails?.model?.detail?.total ||
              companySubscriptionDetails?.detail?.total}
          </p>
        </div>
      ) : null}

      {/* Next Recurring Payment */}
      {companySubscriptionDetails?.model?.detail?.next_recurring_payment ||
      companySubscriptionDetails?.detail?.next_recurring_payment ? (
        <div className="flex items-center justify-end space-x-1">
          <p>Next Recurring Payment: </p>
          <p>
            $
            {companySubscriptionDetails?.model?.detail
              ?.next_recurring_payment ||
              companySubscriptionDetails?.detail?.next_recurring_payment}
          </p>
        </div>
      ) : null}
    </div>
  );
};

export default SubscriptionSummary;
